<template>
		<div class="content">
			<div class="information">
        <div class="mission-t fs50 mt20">{{$t('language')}}</div>
        <div class="en-list mt50 fw7">
        	<div class="title2 app-en fen" :class="{'active':isShow=='en'}" @click="getLang(2,'en')"><img width="35" src="../../static/images/en.jpg">English</div>
        	<div class="title2 fen" :class="{'active':isShow=='bur'}" @click="getLang(2,'bur')"><img width="35" src="../../static/images/en1.jpg">မြန်မာ</div>
        </div>
        <div class="ac mt50">
          <button class="btn btn-blue fw7" style="padding: 10px 20px;" @click="getLang(1)">{{$t('change')}}</button>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        lang:'',
        isShow:'bur',
      }
    },
	created(){
    if(localStorage.getItem('lang')){
      this.isShow = localStorage.getItem('lang')
    }
	},
    methods: {
      back(){
        this.$router.go(-1);
      },
      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          this.$router.push({path:'/',query:{}});
          location.reload()
        }else{
          this.isShow = lang
          this.lang = lang
        }
      },
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/language.vue